import React from 'react'

import ProductPricing from 'customizer/pricing/components/ProductPricing'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import ZoomControls from 'themes/common/components/controls/ZoomControls'
import ShareControlFactory from 'themes/common/components/controls/ShareControlFactory'

import './DisplayerTopSection.scss'

export interface DisplayerTopSectionProps {
  isTouch?: boolean
  isZoomed?: boolean
  isZoomable?: boolean
  isZoomDisabled?: boolean
  zoomIn: () => void
  zoomOut: () => void
}

const DisplayerTopSection = ({
  isTouch,
  isZoomed,
  isZoomable,
  isZoomDisabled,
  zoomIn,
  zoomOut,
}: DisplayerTopSectionProps) => {
  const priceStyle = useThemeSettings('price')

  return (
    <div className="displayer-top-section" style={{ minHeight: priceStyle.priceFontSize }}>
      <ProductPricing
        className="displayer-top-section__pricing"
        style={{
          marginLeft: ['right', 'center'].includes(priceStyle.pricePosition) ? 'auto' : 0,
          marginRight: ['left', 'center'].includes(priceStyle.pricePosition) ? 'auto' : 0,
          fontFamily: priceStyle.priceFont.fontFamily,
          color: priceStyle.priceColor,
          fontSize: priceStyle.priceFontSize,
        }}
      />
      <div
        className="displayer-top-section__controls"
        style={{ position: 'absolute', [priceStyle.pricePosition === 'right' ? 'left' : 'right']: 0 }}
      >
        {isZoomable && !isTouch && (
          <ZoomControls
            isDisabled={isZoomDisabled}
            isZoomed={isZoomed}
            onZoomInClick={zoomIn}
            onZoomOutClick={zoomOut}
          />
        )}
        <ShareControlFactory tooltipPosition="bottom" />
      </div>
    </div>
  )
}

export default DisplayerTopSection
